import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import { PCFRequestStatus } from '../../shared/enums/pcf-request';
import styles from './RequestStatus.module.css';

type RequestStatusProps = {
  status: PCFRequestStatus | null;
  isFootprintUpdated?: boolean;
};

export default function RequestStatus({ status, isFootprintUpdated }: RequestStatusProps) {
  const { t } = useTranslation();

  const determineTagClass = () => {
    if (isFootprintUpdated) {
      return styles['updated-tag'];
    }

    switch (status) {
      case PCFRequestStatus.Complete:
        return styles['complete-tag'];
      case PCFRequestStatus.Pending:
        return styles['pending-tag'];
      case PCFRequestStatus.Rejected:
        return styles['rejected-tag'];
      case PCFRequestStatus.Outdated:
        return styles['expired-tag'];
      default:
        return styles['open-tag'];
    }
  };

  const determineStatusText = () => {
    if (isFootprintUpdated) {
      return t('pcfRequest.updated');
    }

    if (!status) {
      return t(`pcfRequest.${PCFRequestStatus.Open}`);
    } else {
      return t(`pcfRequest.${status}`);
    }
  };

  return (
    <Tag rounded className={classNames('text-sm font-medium px-2 py-1', determineTagClass())}>
      {determineStatusText()}
    </Tag>
  );
}
